import $ from 'jquery';

const getEmbed = url => new Promise((resolve, reject) => {
    const embedlyURL = 'https://api.embedly.com/1/oembed?';
    const key = '5b32b6c7cfde4287bbad7cce3cd68010';
    $.get(embedlyURL + $.param({ key, url }))
        .done(data => resolve(data))
        .fail(error => reject(error));
});

export default getEmbed;
